import React from "react";
import Typography from "@mui/material/Typography";

const CompanyFieldSection = ({children, classes, icon, subtitle, title}) => (
	<section className={classes.fieldSection}>
		<header className={classes.fieldSectionHeader}>
			<div className={classes.fieldSectionCopy}>
				<Typography className={classes.fieldSectionTitle}>{title}</Typography>
				{subtitle && (
					<Typography className={classes.fieldSectionSubtitle}>{subtitle}</Typography>
				)}
			</div>
			{icon && (
				<span className={classes.fieldSectionIcon}>
					{icon}
				</span>
			)}
		</header>
		{children}
	</section>
);

export default React.memo(CompanyFieldSection);
